import {
  ChargeSmallCard,
  InnerProgress,
  ProgressBar,
  GapLine,
} from "@/pages/profile/components/atom";
import styled from "styled-components";
import { useCapacityInfo } from "@/pages/profile/components/profile-charge-card/components/charge-small-card/hooks/useCapacityInfo";
import { useTranslation } from "react-i18next";

export function CapacityCard() {
  const { freeCapacity, usedCapacity, capacityRate } = useCapacityInfo();
  const freeCapacityStr = freeCapacity
    ? `${freeCapacity?.storage}${freeCapacity?.unit}`
    : 0;
  const usedCapacityStr = usedCapacity
    ? `${usedCapacity?.storage}${usedCapacity?.unit}`
    : 0;

  const { t } = useTranslation("profile");
  return (
    <ChargeSmallCard className="capacity-card">
      <CapacityTextWrapper>
        <span>{t("free_capacity")}</span>
        <CapacityDetail>
          <span>
            {usedCapacityStr} / {freeCapacityStr}
          </span>
          <GapLine height="8px" className="capacity" />
          <span>{capacityRate <= 100 ? `${capacityRate}%` : ""}</span>
        </CapacityDetail>
      </CapacityTextWrapper>
      <ProgressBar>
        <CurrentProgress percent={capacityRate < 100 ? capacityRate : 100} />
      </ProgressBar>
    </ChargeSmallCard>
  );
}

const CapacityDetail = styled.div`
  height: 17px;
  line-height: 17px;
  text-align: right;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const CurrentProgress = styled(InnerProgress)`
  background: var(--main-color);
`;

const CapacityTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #d9dfe0;
`;
